import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function Refund() {
  return (
    <div data-testid="refund-page">
      <LegalLayout title="Refund Policy" lastUpdated="February 2026">
        <p>
          JFeva Solutions, LLC stands behind its work. This Refund Policy explains when deposits and payments are
          refundable, when they are not, and how to request a refund. This policy supplements — and should be read
          alongside — our <a className="underline hover:text-[color:var(--brand-ink)]" href="/terms">Terms &amp; Conditions</a>.
        </p>

        <Section title="1. Deposits" testid="refund-deposits">
          <ul className="list-disc pl-6 space-y-1">
            <li><span className="text-[color:var(--brand-ink)] font-medium">Before materials are ordered</span> — your deposit is fully refundable within 3 business days of cancellation, less any pre-approved consultation or site-visit fees.</li>
            <li><span className="text-[color:var(--brand-ink)] font-medium">After materials are ordered</span> — your deposit is refundable minus the cost of non-returnable materials, special-order items, supplier restocking fees, and any labor already performed (such as demo, substrate prep, or measuring).</li>
          </ul>
        </Section>

        <Section title="2. Labor Already Performed" testid="refund-labor">
          <p>
            Labor completed in good faith (demolition, substrate repair, waterproofing, measurements, site preparation,
            etc.) is not refundable. If a project is cancelled mid-way, the balance refunded will reflect any materials
            still returnable to the supplier.
          </p>
        </Section>

        <Section title="3. Completed Projects — Workmanship Issues" testid="refund-workmanship">
          <p>
            If an installation defect is reported in writing within our one-year workmanship warranty period, we will
            inspect the issue and either repair it at no cost or, where repair is not practical, refund the portion of
            the project price corresponding to the defective area. Repair is the primary remedy; a refund is offered
            only when repair cannot reasonably resolve the issue.
          </p>
          <p>
            Issues outside our control — such as water damage, structural movement, misuse, or improper cleaning agents —
            are not covered.
          </p>
        </Section>

        <Section title="4. Material Supplied by Customer" testid="refund-customer-materials">
          <p>
            If you supply your own flooring, tile, grout, adhesive, or other materials, we cannot refund the cost of those
            materials. We will install customer-supplied materials to industry standards, but defects originating in
            customer-supplied material are not covered under our workmanship warranty.
          </p>
        </Section>

        <Section title="5. How to Request a Refund" testid="refund-howto">
          <ol className="list-decimal pl-6 space-y-1">
            <li>Email <a className="underline hover:text-[color:var(--brand-ink)]" href="mailto:info@jfeva.com">info@jfeva.com</a> or call <a className="underline hover:text-[color:var(--brand-ink)]" href="tel:8502520162">850-252-0162</a> within 30 days of the issue arising.</li>
            <li>Include your project address, estimate or invoice number, photos (if applicable), and a brief description.</li>
            <li>We will respond within 5 business days with an inspection date (if needed) or a resolution offer.</li>
            <li>Approved refunds are issued via the original payment method within 10 business days of resolution.</li>
          </ol>
        </Section>

        <Section title="6. Chargebacks" testid="refund-chargebacks">
          <p>
            We ask that you contact us first before initiating a chargeback with your bank or card issuer. Chargebacks
            filed without first attempting resolution with us may delay refund processing and may be contested with
            documentation of completed work.
          </p>
        </Section>

        <Section title="7. Dispute Resolution" testid="refund-dispute">
          <p>
            If we cannot reach agreement, both parties agree to attempt good-faith mediation in Florida before pursuing
            legal remedies. Any legal action will be filed in the state or federal courts located in Florida, in
            accordance with our <a className="underline hover:text-[color:var(--brand-ink)]" href="/terms">Terms &amp; Conditions</a>.
          </p>
        </Section>

        <Section title="8. Contact" testid="refund-contact">
          <p>
            JFeva Solutions, LLC — <a className="underline hover:text-[color:var(--brand-ink)]" href="mailto:info@jfeva.com">info@jfeva.com</a> · <a className="underline hover:text-[color:var(--brand-ink)]" href="tel:8502520162">850-252-0162</a>
          </p>
        </Section>
      </LegalLayout>
    </div>
  );
}
